import React from 'react';
import { Form, Badge } from 'react-bootstrap';
import { useLang } from "../../../contexts/LanguageContext";
import { useAuth } from "../../../contexts/AuthContext";
import ipa from '../../../images/ipa.svg';
import fontsize from '../../../images/fontsize.svg';

export const TextSettings = ({ preferences, onShowLemmaChange, onFontSizeChange, onChange }) => {
  const { t } = useLang();
  const { tier } = useAuth();
  const isFree = tier === 'free';

  const handleShowLemmaChange = (e) => {
    const val = e.target.checked ? 1 : 0;
    onChange('showLemma', val);
    onShowLemmaChange(val === 1);
  };

  const handleFontSizeChange = (e) => {
    onChange('fontSize', e.target.value);
    onFontSizeChange(e.target.value);
  };

  return (
    <>
      <div className="pb-5 container-fluid">
        <div className="row">
          <div className="col-10 p-0">
            <label htmlFor="showLemma" className="settings-label">
              <img src={ipa} className="settingsLabelIcon" alt={t("CHAPTER_SHOW_PHONOLOGY_ICON")} />
              {t("CHAPTER_SHOW_PHONOLOGY")}
              {isFree && <Badge bg="warning" text="dark" className="ms-2" style={{ fontSize: '0.65em' }}>PREMIUM</Badge>}
            </label>
            <p className="settingsDesc">{t("CHAPTER_SHOW_PHONOLOGY_DESC")}</p>
          </div>
          <div className="col-2 form-check form-switch">
            <Form.Check 
              type="switch"
              id="showLemma"
              name="showLemma"
              onChange={handleShowLemmaChange}
              checked={isFree ? false : preferences.showLemma}
              disabled={isFree}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-12 p-0">
            <label htmlFor="fontSizeDesc" className="settings-label"><img src={fontsize} className="settingsLabelIcon" alt={t("CHAPTER_TEXT_SIZE_ICON")} />{t("CHAPTER_TEXT_SIZE")}</label>
          </div>
          <div className="col-12 p-0 text-center">
            {[0, 1, 2, 3, 4].map(size => (
              <div key={size} className={`uTextButton ${parseInt(preferences.fontSize, 10) === size ? 'uTextSelected' : ''}`}>
                <input type="radio" name="fontSize" value={size} id={`uTextMenu${size}`} onChange={handleFontSizeChange} />
                <label htmlFor={`uTextMenu${size}`} className={`uText${String.fromCharCode(65 + size)}`} id={`labelFontSize${String.fromCharCode(65 + size)}`}>{t("CHAPTER_TS_CHARACTER")}</label>
              </div>
            ))}
          </div> 
        </div>
      </div>
    </>
  );
};
